var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepCoach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6839 19.6535C10.9086 22.428 4.78818 20.806 2.01371 16.0306C-0.760761 11.2553 0.8612 5.13488 5.63658 2.36039C7.11295 1.50262 8.78434 1.03718 10.4916 1.00835L11.9715 0.983342L11.2239 2.26175C9.01338 6.02765 10.2743 10.8725 14.0402 13.083C15.49 13.934 17.1734 14.3008 18.8459 14.13L20.3203 13.9821L19.6783 15.3151C18.8169 17.1324 17.424 18.6453 15.6839 19.6535ZM6.51726 3.77634C2.53148 6.07752 1.16585 11.1741 3.46704 15.1599C5.76823 19.1457 10.8648 20.5113 14.8506 18.2101C15.8866 17.6122 16.7794 16.7953 17.4667 15.8163C12.1922 15.4997 8.17315 10.9671 8.48982 5.69263C8.54902 4.70655 8.76058 3.73559 9.11702 2.81426C8.20182 2.98396 7.32247 3.30936 6.51726 3.77634ZM14.9939 6.29167L16.8082 7.48914L16.6791 5.31875L17.8765 3.50447L15.7061 3.63362L13.8919 2.43615L14.021 4.60653L12.8243 6.42038L14.9939 6.29167ZM20.7058 10.0183C20.3072 10.2485 20.1707 10.7581 20.4008 11.1567C20.6309 11.5553 21.1406 11.6919 21.5392 11.4617C21.9377 11.2316 22.0743 10.7219 21.8442 10.3234C21.6141 9.92479 21.1044 9.78822 20.7058 10.0183ZM14.709 9.63159C14.3105 9.86171 14.1739 10.3714 14.404 10.77C14.6341 11.1685 15.1438 11.3051 15.5424 11.075C15.941 10.8449 16.0775 10.3352 15.8474 9.93662C15.6173 9.53804 15.1076 9.40147 14.709 9.63159Z",
    fill: "url(#paint0_linear_6573_1839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1839",
    x1: 1.90386,
    y1: 5.90152,
    x2: 19.0171,
    y2: 15.7954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepCoach);
export default __webpack_public_path__ + "static/media/sleepCoach.31dc5a2954fdee9158a37b5a5a604313.svg";
export { ForwardRef as ReactComponent };